import { useDownloadsRemainingLazyQuery } from 'generated/graphql';



export function useQuery() {
  const [fnQuery] = useDownloadsRemainingLazyQuery({ fetchPolicy: 'network-only' });

  async function fnWrappedQuery() {
    const results = await fnQuery();

    return {
      allAccessEnabled: results.data?.allAccessEnabled ?? false,
      totalUsage: results.data?.loggedInUser?.downloadUsageForCycle ?? 0,
      totalAllowed: results.data?.loggedInUser?.downloadsAllowed ?? 0,
      subscriptionStatus: results.data?.loggedInUser?.subscriptionInfo?.status
    };
  }

  return fnWrappedQuery;
}
